import * as t from './actionTypes';

const initialState = { isLoading: false, settings: {} };

const homeReducer = (state = initialState, action) => {

    switch (action.type) {
        case t.SET_BUSY:
            return Object.assign({}, state, { isLoading: true });

        case t.UNSET_BUSY:
            return Object.assign({}, state, { isLoading: false });

        case t.HOME_LOAD_SUCCESS:
            const home = action.home;

            return Object.assign({}, state, { settings: home });

        default:
            return state;
    }
};

export default homeReducer;
